<template>
	<Dialog :visible="true" :closable="false"  header="Planning Allocation Record" :modal="true" class="p-fluid custom-dialog">
    Are you sure you want to delete the the following records?:
    <ul>
      <li v-for="id in selectedProductIds" :key="`id_${id}`">
        {{id}}
      </li>
    </ul>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="closeDeleteConfirm"/>
        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="confirmDelete"/>
      </template>
  </Dialog>
</template>


<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: "DeleteConfirm",
  components: {
    Button,
    Dialog
  },
  props: {
    selectedProductIds: Array,
    closeDeleteConfirm: Function,
    confirmDelete: Function
  }
};
</script>

<style>
.custom-dialog .p-inputtext {
  padding: 14px 10px;
  font-size: 16px;
}

.liability-chart.p-inputtext,
.liability-chart.p-dropdown {
  width: 100%;
}

.liability-chart .p-inputtext {
  font-size: 14px;
}
.comment-content {
  color: #00424a;
  font-weight: 700;
}
.hidden {
  display: none;
}
.data-table-parent-container  {
  overflow: hidden;
}

.data-table-parent-container .p-datatable-scrollable-header {
  overflow: unset;
}

.liability-chart.p-datatable .multi-option {
  color: #4d4d4d !important;
  width: 100%;
}
.liability-chart  .p-datatable-tbody > tr.cloned-liabilities-row {
  background: #4d4d4d;
}

.liability-chart .p-datatable-tbody > tr.cloned-liabilities-row > td {
  color: #fff;
}

.liability-count {
  color: #4d4d4d;
  font-size: 12px;
  margin-top: 4px;
}

.data-table-parent-container .p-paginator-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.data-table-parent-container .p-datatable table {
  margin-bottom: 0;
}

.data-table-parent-container .p-datatable .p-datatable-scrollable-footer {
  background: unset;
}

.tool-bar-styling .p-button-info.p-button, .tool-bar-styling .p-button, .tool-bar-styling .p-button.p-button-help {
  background: #00424a;
  border: 1px solid #00424a;
  color: #fff;
}

.tool-bar-styling .p-button-info.p-button:disabled{
  background: #fff;
  border: 1px solid #333;
  color: #000;
  cursor: not-allowed;
}
</style>
